import { withStyles } from '@material-ui/styles';
import HubForm from './HubForm';
import styles from './styles';

export default withStyles(styles)(HubForm);
